import PropTypes from "prop-types"
import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"

const SummaryHeader = ({
  heading,
  description,
  children,
  childrenWidth,
  childrenVerticalAlign,
  style
}) => (
  <Grid.Row className="SummaryHeader__Row" columns={children ? 2 : 1}>
    <Grid.Column
      width={children ? 9 : 16}
      style={{ borderRight: "1px solid #D7D7D7", ...style }}
    >
      <h1 className="SummaryHeader__Heading">{heading}</h1>
      {typeof description === "string" ? (
        <p style={{ fontSize: "1rem", color: "#6A6A6A" }}>{description}</p>
      ) : (
        description()
      )}
    </Grid.Column>
    {children && (
      <Grid.Column width={7} verticalAlign={childrenVerticalAlign || "bottom"}>
        {children}
      </Grid.Column>
    )}
  </Grid.Row>
)

SummaryHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  childrenWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SummaryHeader.defaultProps = {
  childrenWidth: null,
  description: ""
}
export default SummaryHeader
